import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    title: _ctx.modal?.title,
    modelValue: _ctx.modal !== null,
    "body-class": "d-none",
    "footer-class": "border-top-0 d-flex justify-content-between",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ($event === false && (_ctx.modal = null)))
  }, {
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modal = null)),
        class: "btn btn-outline-dark btn-sm text-capitalize-first"
      }, _toDisplayString(_ctx.modal?.cancelTitle ?? _ctx.helper.trans('button.cancel')), 1),
      _createVNode(_component_LoaderWrapper, {
        ref: "loader",
        zoom: 0.5
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onOkClick())),
            class: "btn btn-outline-danger btn-sm text-capitalize-first"
          }, _toDisplayString(_ctx.modal?.okTitle ?? _ctx.helper.trans('button.ok')), 1)
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}